import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/700.css";
import { Header } from "./components/app/Header";
import { About } from "./components/app/About";
import { Experience } from "./components/app/Experience";
import { Projects } from "./components/app/Projects";
import { Blog } from "./components/app/Blog";
import { Contact } from "./components/app/Contact";

function App() {
  return (
    <>
      <Header />
      <main>
        <About />
        <Experience />
        <Projects />
        <Blog />
        <Contact />
      </main>
    </>
  );
}

export default App;
